import { getApiVersion, http } from '@vt/apis/lib-ex'
import { isPlainObject, isArray, keys, isString } from 'lodash-es'
import qs from 'qs'
import { listToTree } from '@ow/utils'

function isFunction(value) {
  return !!value && typeof value === 'function'
}

const evalData = (code, data) => {
  let fn
  try {
    const wrCode = `fn=${code}`
    // eslint-disable-next-line no-eval
    eval(wrCode)
    if (isFunction(fn)) {
      return fn(data)
    }
  } catch (error) {
    console.log(error)
    return data
  }
  return null
}

const mapInfos = (appId, vtProject) => {
  const { userInfo = {} } = vtProject || {}
  // 以下参数应该可定制
  return {
    appId,
    organ: userInfo.name,
    ...userInfo,
  }
}

const transformParams = (params, appId, vtProject) => {
  const obj = { ...params }
  const infos = mapInfos(appId, vtProject)
  keys(obj).forEach((v) => {
    if (isString(obj[v]) && obj[v].includes('$')) {
      obj[v] = infos[v]
    } else if (obj[v] === 'nowtime') {
      obj[v] = new Date().getTime()
    }
  })
  return obj
}

const defaultMethod = 'get'
export default class Extend {
  constructor(appId, tbNameId, vtProject) {
    this.appId = appId
    this.vtProject = vtProject
  }

  // 转换接口域名、appId、请求参数
  transUrl(url, opts) {
    let str = url
      .replace('$apiVersion', getApiVersion())
      .replace('$appId', this.appId)
    // 需判断类型
    if (opts.params && isPlainObject(opts.params)) {
      const obj = transformParams(opts.params, this.appId, this.vtProject)
      str += `?${qs.stringify(obj)}`
    }
    return str
  }

  fetch(url, opts) {
    const finalUrl = this.transUrl(url, opts)
    return http()
      [opts.method || defaultMethod](finalUrl)
      .json()
      .then((data) => {
        if (opts.transform) {
          return evalData(opts.transform, data)
        }

        return data
      })
  }

  fetchTree(url, opts) {
    return this.fetch(url, opts).then((data) => {
      return listToTree(isArray(data) ? evalData(data) : [])
    })
  }
}
